export enum CAMPAIGN_MANAGEMENT_VIEW {
  HAD_DELIVERY = 'HAD_DELIVERY',
  ACTIVE_ADS = 'ACTIVE_ADS'
}

export enum CAMPAIGN_MANAGEMENT_TAB {
  CAMPAIGNS = 'CAMPAIGNS',
  AD_SETS = 'AD_SETS',
  ADS = 'ADS',
  ADS_REVIEW = 'ADS_REVIEW'
}

export enum CAMPAIGN_TYPE {
  CAMPAIGN = 'CAMPAIGN',
  ADSET = 'ADSET',
  ADS = 'ADS'
}

export enum CAMPAIGN_CONVERSION_OPTIONS {
  MESSAGE_DESTINATIONS = 'VALUE_CONTENT_VIEW',
  ON_YOUR_AD = 'VALUE_LISTING_INTERACTION',
  CALLS = 'VALUE_CONTACT',
  WEBSITE = 'VALUE_SCHEDULE',
  FACEBOOK_PAGE = 'FACEBOOK_PAGE',
  MESSENGER = 'MESSENGER',
  INSTANT_FORMS_AND_MESSENGER = 'INSTANT_FORMS_AND_MESSENGER'
}

export enum CAMPAIGN_OPTIMIZE_GOAL {
  // AWARENESS
  AWARENESS_REACH = 'REACH',
  AWARENESS_BRAND = 'IMPRESSIONS',

  // ENGAGEMENT
  ENGAGEMENT_VIDEO = 'THRUPLAY',
  ENGAGEMENT_POST = 'POST_ENGAGEMENT',
  ENGAGEMENT_MESSAGE = 'CONVERSATIONS',

  // LEAD
  LEAD_FORM = 'LEAD_GENERATION',
  LEAD_WEBSITE_AND_SALES = 'OFFSITE_CONVERSIONS'
}

export enum ENGAGEMENT_TYPE {
  VIDEO_VIEWS = 'THRUPLAY',
  POST_ENGAGEMENT = 'POST_ENGAGEMENT',
  EVENT_RESPONSES = 'EVENT_RESPONSES',
  REMINDERS_SET = 'REMINDERS_SET'
}

export enum OBJECTIVE_CAMPAIGN {
  AWARENESS = 'AWARENESS',
  ENGAGEMENT = 'ENGAGEMENT',
  LEADS = 'LEADS',
  SALES = 'SALES'
}

export enum OBJECTIVE_SUB_CAMPAIGN {
  REACH = 'Reach',
  BRAND = 'Brand',
  MESSAGES = 'Messages',
  VIEWS = 'Video views',
  ENGAGEMENT = 'Engagement',
  LEAD_FORM = 'Lead form',
  LEAD_WEBSITE = 'Lead website',
  CONVERSION = 'Conversion'
}

export enum GENDER {
  ALL = 'All',
  MALE = 'Male',
  FEMALE = 'Female'
}

export enum BUDGET_TYPE {
  DAILY = 'Daily',
  LIFETIME = 'Lifetime'
}

export enum CAMPAIGN_FILTER_ENUM {
  NAME_AND_ID = 'NAME_AND_ID',
  CAMPAIGN_NAME = 'CAMPAIGN_NAME',
  SET_AD_NAME = 'SET_AD_NAME',
  AD_NAME = 'AD_NAME',
  CAMPAIGN_ID = 'CAMPAIGN_ID',
  SET_AD_ID = 'SET_AD_ID',
  AD_ID = 'AD_ID',
  DELIVERY = 'DELIVERY',
  CAMPAIGN_DELIVERY = 'CAMPAIGN_DELIVERY',
  AD_SET_DELIVERY = 'AD_SET_DELIVERY',
  AD_DELIVERY = 'AD_DELIVERY',
  OBJECTIVE = 'OBJECTIVE',
  AB_TEST = 'AB_TEST'
}

export enum AD_SET_AUDIENCE_OPTION {
  SAVED_AUDIENCE = 'USE_SAVED',
  CREATE_AUDIENCE = 'CREATE'
}

export enum CAMPAIGN_PROFILE_COL_ENUM {
  DEFAULT = 'DEFAULT',
  LEAD_WEB = 'LEAD_WEB',
  LEAD_FORM = 'LEAD_FORM',
  CONVERSION = 'CONVERSION',
  MESSENGER = 'MESSENGER',
  CUSTOMIZE = 'CUSTOMIZE'
}

export enum CAMPAIGN_COL_ENUM {
  ON_OFF = 'ON_OFF',
  CAMPAIGN = 'CAMPAIGN',
  CAMPAIGN_ID = 'CAMPAIGN_ID',
  OBJECTIVE = 'OBJECTIVE',
  PAGE_NAME = 'PAGE_NAME',
  DELIVERY = 'DELIVERY',
  BUDGET = 'BUDGET',
  AMOUNT_SPENT = 'AMOUNT_SPENT',
  IMPRESSIONS = 'IMPRESSIONS',
  CPM = 'CPM',
  REACH = 'REACH',
  FREQUENCY = 'FREQUENCY',
  RESULTS = 'RESULTS',
  COST_PER_RESULT = 'COST_PER_RESULT',
  RESULT_RATE = 'RESULT_RATE',
  LINK_CLICKS = 'LINK_CLICKS',
  CPC_ALL = 'CPC_ALL',
  CTR_ALL = 'CTR_ALL',
  UNIQUE_CTR = 'UNIQUE_CTR',
  VIDEO_AVERAGE_PLAY_TIME = 'VIDEO_AVERAGE_PLAY_TIME',
  POST_ENGAGEMENTS = 'POST_ENGAGEMENTS',
  LEAD = 'LEAD',
  ROAS = 'ROAS',
  CLICKS_ALL = 'CLICKS_ALL',
  UNIQUE_CLICKS = 'UNIQUE_CLICKS',

  //LEAD WEB
  OUTBOUND_CLICKS = 'OUTBOUND_CLICKS',
  UNIQUE_OUTBOUND_CLICKS = 'UNIQUE_OUTBOUND_CLICKS',
  CTR = 'CTR',
  CPC = 'CPC',
  LANDING_PAGE_VIEWS = 'LANDING_PAGE_VIEWS',
  WEBSITE_LEADS = 'WEBSITE_LEADS',

  // LEAD FORM
  UNIQUE_LINK_CLICKS = 'UNIQUE_LINK_CLICKS',
  COST_PER_UNIQUE_LINK_CLICK = 'COST_PER_UNIQUE_LINK_CLICK',
  POST_COMMENTS = 'POST_COMMENTS',

  //CONVERSION

  //MESSAGING
  NEW_MESSAGING_CONTACTS = 'NEW_MESSAGING_CONTACTS',
  RETURNING_MESSAGING_CONTACTS = "RETURNING_MESSAGING_CONTACTS",
  MESSAGING_CONVERSATIONS_REPLIED = 'MESSAGING_CONVERSATIONS_REPLIED',
  MESSAGING_CONVERSATIONS_STARTED = 'MESSAGING_CONVERSATIONS_STARTED',
  MESSAGING_CONTACTS = 'MESSAGING_CONTACTS',
  BLOCKS = 'BLOCKS',
  BLOCK = 'BLOCK',
  POST_REACTIONS = 'POST_REACTIONS',

  END = 'END',
  SCHEDULED = 'SCHEDULED',

  POST_SAVES = 'POST_SAVES',
  POST_SHARES = 'POST_SHARES',
  PAGE_ENGAGEMENT = 'PAGE_ENGAGEMENT',
  SUBCRIPTIONS = 'SUBCRIPTIONS',
  CPP = 'CPP',
  FOLLOWS_OR_LIKES = 'FOLLOWS_OR_LIKES',
  ADDS_OF_PAYMENT_INFO = 'ADDS_OF_PAYMENT_INFO',
  ADDS_TO_CART = 'ADDS_TO_CART',
  CUSTOMEVENT = 'CUSTOMEVENT',

  PURCHASES = 'PURCHASES',
  CONTENT_VIEW = 'CONTENT_VIEW',
  LEVELS_ACHIEVED = 'LEVELS_ACHIEVED',
  APPLICATIONS_SUBMITTED = 'APPLICATIONS_SUBMITTED',
  CONTACTS = 'CONTACTS',
  APPOINTMENTS_SCHEDULED = 'APPOINTMENTS_SCHEDULED',
  REGISTRATIONS_COMPLETED = 'REGISTRATIONS_COMPLETED',
  CHECKOUTS_INITIATED = 'CHECKOUTS_INITIATED',
  OUTBOUND_CTR = 'OUTBOUND_CTR',
  UNIQUE_OUTBOUND_CTR = 'UNIQUE_OUTBOUND_CTR',
  UNIQUE_CTR_ALL = 'UNIQUE_CTR_ALL',

  // number
  THREE_SECOND_VIDEO_PLAYS = '3_SECOND_VIDEO_PLAYS',
  VIDEO_PLAYS_AT_25 = 'VIDEO_PLAYS_AT_25',
  VIDEO_PLAYS_AT_50 = 'VIDEO_PLAYS_AT_50',
  VIDEO_PLAYS_AT_75 = 'VIDEO_PLAYS_AT_75',
  VIDEO_PLAYS_AT_95 = 'VIDEO_PLAYS_AT_95',
  VIDEO_PLAYS_AT_100 = 'VIDEO_PLAYS_AT_100',
  VIDEO_PLAYS = 'VIDEO_PLAYS',
  THRUPLAYS = 'THRUPLAYS',

  META_PIXEL = "META_PIXEL",
  HEADLINE_AD_SETTINGS = "HEADLINE_AD_SETTINGS",
  BODY_AD_SETTINGS = "BODY_AD_SETTINGS",
  LINK_AD_SETTINGS = "LINK_AD_SETTINGS",
  STARTS = "STARTS",
  ENDS = "ENDS",
  AD_NAME = "AD_NAME",
  AD_SET_ID = "AD_SET_ID",
  AD_ID = "AD_ID",
  AD_SET_NAME = "AD_SET_NAME"
}

export enum AD_SETUP {
  CREATE_AD = 'CREATE_AD',
  USE_EXISTING_POST = 'USE_EXISTING_POST',
  USE_TEMPLATE = 'USE_TEMPLATE'
}

export enum MESSAGE_TEMPLATE {
  CREATE_NEW = 'CREATE_NEW',
  USE_EXISTING = 'USE_EXISTING'
}

export enum QUESTIONS_AND_RESPONSE {
  QUESTIONS_AND_RESPONSES = 'QUESTIONS_AND_RESPONSES',
  QUICK_REPLIES = 'QUICK_REPLIES',
  BUTTONS = 'BUTTONS'
}

export enum QUESTION_TYPE_ENUM {
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  SHORT_ANSWER = 'SHORT_ANSWER',
  APPOINTMENT_REQUEST = 'APPOINTMENT_REQUEST'
}

export enum ADDITIONAL_ACTION_ENUM {
  GO_TO_WEBSITE = 'VIEW_WEBSITE',
  VIEW_FILE = 'VIEW_ON_FACEBOOK',
  CALL_BUSINESS = 'CALL_BUSINESS',
  CHAT_ON_MESSENGER = 'P2B_MESSENGER'
}

export const ADDITIONAL_ACTION_BUTTON = {
  [ADDITIONAL_ACTION_ENUM.GO_TO_WEBSITE]: 'View website',
  [ADDITIONAL_ACTION_ENUM.VIEW_FILE]: 'Download',
  [ADDITIONAL_ACTION_ENUM.CALL_BUSINESS]: 'Call now',
  [ADDITIONAL_ACTION_ENUM.CHAT_ON_MESSENGER]: 'Chat on Messenger'
};

export enum TYPE_BACKGROUND_ENUM {
  YOUR_AD = 'YOUR_AD',
  UPLOADED = 'UPLOADED'
}

export const FORMAT_TYPE = {
  VALUE_SINGLE_IMAGE: 'VALUE_SINGLE_IMAGE',
  VALUE_SINGLE_VIDEO: 'VALUE_SINGLE_VIDEO',
  CAROUSEL: 'CAROUSEL',
  VALUE_CAROUSEL_IMAGES_MULTI_ITEMS: 'VALUE_CAROUSEL_IMAGES_MULTI_ITEMS',
  VALUE_COLLECTION_VIDEO: 'VALUE_COLLECTION_VIDEO',
  VALUE_CAROUSEL_IMAGES_SINGLE_ITEM: 'VALUE_CAROUSEL_IMAGES_SINGLE_ITEM'
};

export enum CATEGORIES_TYPE {
  FINANCIAL = 'FINANCIAL_PRODUCTS_SERVICES',
  EMPLOYMENT = 'EMPLOYMENT',
  HOUSING = 'HOUSING'
}

export enum PERFORMANCE_GOAL {
  BRAND = 'Maximise number of impressions',
  REACH = 'Maximise reach of ads',
  VIDEO = 'Maximise ThruPlay views',
  POST = 'Maximise engagement with a post',
  MESSAGE = 'Maximise number of conversations',
  LEAD_FORM = 'Maximise number of leads',
  LEAD_WEBSITE = 'Maximise number of conversions',
  CONVERSTION = 'Maximise number of conversions'
}

export enum EMAIL_STATISTIC {
  SEND = 'SEND',
  DELIVERED = 'DELIVERED',
  CLICKED = 'CLICKED',
  BOUNCED = 'BOUNCED',
  // SPAM_BLOCKED = 'SPAM_BLOCKED',
  LEADS = 'LEADS'
}
